module.exports = " <div class=\"preloader-wrapper active\" :style=\"{'width': size + 'px', 'height': size + 'px'}\"> <div class=\"spinner active\" :class=\"['spinner-' + color]\"> <div class=\"circle-clipper left\"> <div class=circle :style=\"{'border-width': borderWidth + 'px'}\"></div> </div> <div class=gap-patch> <div class=circle></div> </div> <div class=\"circle-clipper right\"> <div class=circle :style=\"{'border-width': borderWidth + 'px'}\"></div> </div> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/circular.vue
 ** module id = 433
 ** module chunks = 1
 **/